import React, { useContext } from 'react';
import styled, { ThemeContext } from 'styled-components';
import { BorderedFlex } from '@goodrx/x-core';
const StyledFlex = styled(BorderedFlex)`
  &&&& {
    ${({
  mobileConfig,
  theme
}) => `@media (max-width: ${theme.breakpoints.md}) {
        ${(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.customCss) || ''}
      }`}

    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      ${({
  flex
}) => `flex: ${flex === 'initial' ? flex : '1 1 auto'};`};
    }
  }
  &&& {
    ${({
  tabletConfig
}) => `${(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.customCss) || ''}`}
  }
`;
const alignmentMap = {
  left: 'flex-start',
  center: 'center',
  right: 'flex-end',
  top: 'flex-start',
  middle: 'center',
  bottom: 'flex-end'
};
export const BlockConfig = ({
  className,
  children,
  mobileConfig,
  tabletConfig
}) => {
  var _mobileConfig$backgro, _mobileConfig$backgro2, _tabletConfig$backgro, _tabletConfig$backgro2;

  const theme = useContext(ThemeContext);
  const tabletJustifyContent = tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.align ? alignmentMap[tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.align] : undefined;
  const tabletAlignItems = tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.verticalAlign ? alignmentMap[tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.verticalAlign] : undefined;
  const mobileJustifyContent = mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.align ? alignmentMap[mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.align] : undefined;
  const mobileAlignItems = mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.verticalAlign ? alignmentMap[mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.verticalAlign] : undefined;

  const getThemeSpacing = val => {
    if (val === undefined || val === null) {
      return theme.xSpace[0];
    }

    const num = Number(val);

    if (num < 0) {
      return `-${theme.xSpace[`${num * -1}`]}`;
    }

    return theme.xSpace[val];
  };

  const getThemeWidth = (defaultValue, config) => {
    if (!config || !(config !== null && config !== void 0 && config.preferredWidth)) {
      return defaultValue;
    }

    if (config.preferredWidth === '100%' && config.fillSpace) {
      if (config.marginLeft === undefined || config.marginLeft === null) {
        return '100%';
      } else {
        const num = Number(config.marginLeft);

        if (num < 0) {
          return `calc(100% + ${theme.xSpace[`${num * -1 * 2}`]})`;
        }
      }
    }

    return config.preferredWidth;
  };

  return /*#__PURE__*/React.createElement(StyledFlex, {
    className: className,
    alignItems: {
      _: mobileAlignItems,
      md: tabletAlignItems
    },
    mobileConfig: mobileConfig,
    tabletConfig: tabletConfig,
    backgroundImage: {
      _: mobileConfig !== null && mobileConfig !== void 0 && (_mobileConfig$backgro = mobileConfig.backgroundImage) !== null && _mobileConfig$backgro !== void 0 && _mobileConfig$backgro.url ? `url(${mobileConfig === null || mobileConfig === void 0 ? void 0 : (_mobileConfig$backgro2 = mobileConfig.backgroundImage) === null || _mobileConfig$backgro2 === void 0 ? void 0 : _mobileConfig$backgro2.url})` : 'none',
      md: tabletConfig !== null && tabletConfig !== void 0 && (_tabletConfig$backgro = tabletConfig.backgroundImage) !== null && _tabletConfig$backgro !== void 0 && _tabletConfig$backgro.url ? `url(${tabletConfig === null || tabletConfig === void 0 ? void 0 : (_tabletConfig$backgro2 = tabletConfig.backgroundImage) === null || _tabletConfig$backgro2 === void 0 ? void 0 : _tabletConfig$backgro2.url})` : 'none'
    },
    borderBottomStyle: "solid",
    borderBottomWidth: {
      _: mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.bottomDividerColor ? 1 : '0',
      md: tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.bottomDividerColor ? 1 : '0'
    },
    borderBottomColor: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.bottomDividerColor) || 'initial',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.bottomDividerColor) || 'initial'
    },
    borderTopStyle: "solid",
    borderTopWidth: {
      _: mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.topDividerColor ? 1 : '0',
      md: tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.topDividerColor ? 1 : '0'
    },
    borderTopColor: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.topDividerColor) || 'initial',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.topDividerColor) || 'initial'
    },
    backgroundRepeat: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.backgroundRepeat) || 'no-repeat',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.backgroundRepeat) || 'no-repeat'
    },
    backgroundSize: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.backgroundSize) || 'auto',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.backgroundSize) || 'auto'
    },
    backgroundPosition: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.backgroundPosition) || 'center top',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.backgroundPosition) || 'center top'
    },
    bg: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.backgroundColor) || 'initial',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.backgroundColor) || 'initial'
    },
    flex: {
      _: mobileConfig !== null && mobileConfig !== void 0 && mobileConfig.fillSpace ? '1' : 'initial',
      md: tabletConfig !== null && tabletConfig !== void 0 && tabletConfig.fillSpace ? '1' : 'initial'
    },
    justifyContent: {
      _: mobileJustifyContent,
      md: tabletJustifyContent
    },
    mt: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginTop),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginTop)
    },
    mb: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginBottom),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginBottom)
    },
    ml: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginLeft),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginLeft)
    },
    mr: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.marginRight),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.marginRight)
    },
    pt: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingTop),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingTop)
    },
    pb: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingBottom),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingBottom)
    },
    pl: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingLeft),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingLeft)
    },
    pr: {
      _: getThemeSpacing(mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.paddingRight),
      md: getThemeSpacing(tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.paddingRight)
    },
    textAlign: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.align) || 'match-parent',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.align) || 'match-parent'
    },
    width: {
      _: getThemeWidth('100%', mobileConfig),
      md: getThemeWidth('auto', tabletConfig)
    },
    height: {
      _: (mobileConfig === null || mobileConfig === void 0 ? void 0 : mobileConfig.preferredHeight) || 'auto',
      md: (tabletConfig === null || tabletConfig === void 0 ? void 0 : tabletConfig.preferredHeight) || 'auto'
    }
  }, children);
};